import styled, { css } from "styled-components";

export const AboutTag = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  padding: 40px 70px;

  @media screen and (max-width: 768px) {
    padding: 20px 40px;
  }
`;

export const Founders = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  ul {
    display: flex;
    align-items: center;
    justify-content: space-around;
    width: 100%;
    margin-top: 48px;

    @media screen and (max-width: 768px) {
      margin-top: 24px;
      flex-direction: column;

      li {
        width: 100%;
        margin: 10px 20px;

        img {
          width: 90%;
        }
      }
    }

    li {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;

      img {
        /* width: 250px; */
        margin: 16px auto 21px;
      }
    }
  }
`;

export const ButtonContainer = styled.div`
  margin: 48px auto 80px;
`;

export const Spacer = styled.div`
  ${(props) => css`
    width: 100%;
    height: ${props.size}px;
  `}
`;

export const TimeLineContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;

  @media screen and (max-width: 768px) {
    img {
      width: 100%;
    }
  }

  img {
    margin: 80px auto 30px;
  }
`;

export const InfoPart = styled.div`
  width: 100%;
  margin: 32px auto;

  > p {
    margin: 24px auto 0;
  }
`;

export const MoreInfoPart = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  margin: 80px auto 64px;
  padding-top: 32px;

  @media screen and (max-width: 768px) {
    margin: 4px auto 32px;
    padding-top: 16px;

    div {
      flex-direction: column-reverse;
      align-items: flex-start;
      justify-content: center;
    }
  }

  > div {
    display: flex;
    justify-content: flex-start;
    align-items: space-between;
    margin-top: 32px;
  }
`;

export const CitiesPart = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  width: 60%;

  ul {
    margin-top: 30px;
  }
`;

export const MapPart = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  width: 40%;
  padding: 30px auto;
`;
